import { BitmapFontAsset } from '@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset';
import { TextureAsset } from '@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset';
import { SpineAsset } from '@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset';
import { AssetQualityLevel, AssetsGroup, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/asset/Asset";
import TextureSheets from "./TextureSheets.json";
import SpineAssets from "./SpineAssets.json";

interface ITexturePath {
    SheetName:string,
    Assets:{name:string,path:string}[]
}

interface ISpinePath {
    SheetName:string,
    Assets:{name:string,path:string}[]
}

export class GameAssets {
    
    public static NEW_INTRO_BACKGROUND_PLATE =  "resources/images/intro/newIntroBackgroundPlate.png";
    public static INTRO_BORDER_TILE =  "resources/images/intro/borderTile.png";
    public static FEATURE_1 =  "resources/images/intro/Splash_PrisonBreak.png";
    public static FEATURE_2 =  "resources/images/intro/Splash_XWays.png";
    public static FEATURE_3 =  "resources/images/intro/Splash_Wild.png";
    public static INTRO_LOGO =  "resources/images/intro/Logo_sq2.png";
    public static NOLIMIT_BONUS_ANIMATION =  "resources/images/intro/NolimitBonusAnimation.json";
    public static INTRO_BUY_FEATURE_ICON =  "resources/images/intro/buyFeatureIcon.svg";
    // public static PROMO_FREESPIN =  "nolimit/promo-panel/FREESPIN.png";
    public static MAIN_GAME_REEL_BG:string = "BG_basegame/Transporter";
    public static MAIN_GAME_REEL_BG_AREA:string = "Reel/billboard";
    public static FS_GAME_REEL_BG_AREA:string = "Reel/FSReelBg";
    public static MAIN_GAME_REEL_BG_AREA_GLOW:string = "Reel/billboard_glow";

    public static MAIN_GAME_REEL_DIVIDER:string = "ReelDividers";

    public static INTRO_BACKGROUND:string = "resources/images/intro/introBackground.jpg";

    public static NORMAL_REEL_DIVIDER:string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER:string = "reelDividerNearWin";

    public static RESOURCES_TEST:IResourcesGroupConfig = {intro:[], main:[]};
    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],
        main : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            },
            {
                name : "main",
                assets : [],
                animations : {
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "benchDude" : "Idle_Loops/Bench/L_Bench_",
                    "walkingDude" : "Idle_Loops/Walking/L_Walking_",
                    "Lever" : "X_Ways_Switch/Switch_",
                    "XMelt" : "X_Ways_Melt/Melt_",
                    "Frame_Win_2" : "Frame_Win_2/Win_2_",
                    "Frame_Win_4" : "Frame_Win_4/Win_4_",
                    "Frame_Toggle_1" : "Frame_Toggle_1/Toggle1_",
                    "Frame_Toggle_2" : "Frame_Toggle_2/Toggle2_",
                    "Frame_Toggle_4" : "Frame_Toggle_4/Toggle4_",
                    "XpandSingle" : "X_Ways_Melt_Single/Melt_SIngle_",

                    "lineSplit" : "Effects/split/split",
                    "5Spins_Burn" : "fs_door/burnout/burnout_",
                    "flamedPaper":"Particles/burning_particle/burning_particle_"

                }
            },
            {
                name : "mainJpeg",
                assets : [],
                animations : {
                    "mainBackground" : "mainBackground",
                    "W2_Win" : "Wild_2_Win/W_2_WIN_",
                    "W4_Win" : "Wild_4_Win/W_4_WIN_",
                    "Win_Xplod_A":"Win_Xplod_A/Xplod_A_",
                    "Win_Xplod_B":"Win_Xplod_B/Xplod_B_",
                    "S_W_T" : "Bonus/Bonus_2_Wild/Bonus_2_Wild_",
                    "S_W_A" : "Bonus/Bonus_Attention/Bonus_Attention_",
                    "S_W_E" : "Bonus/Bonus_2_Wild_End/Bonus_2_Wild_End_",
                    "S_W_A_T" : "Bonus/Bonus_2_Wild_Red/Bonus_2_Wild_RED_",
                    "S_W_A_E" : "Bonus/Bonus_2_J_Wild/Bonus_2_JW_",
                    "Blink_Bar" : "Blink_Block/Blink_Block_",

                    "Blink_Bar_Medium" : "Blink_Block",
                    "Blink_Bar_Tiny" : "Blink_Block_Tiny",
                    "Blink_Bar_Small" : "Blink_Block_Small",
                    "Blink_Bar_High" : "Blink_Block_Large",
                    "Logo_FX_1" : "Logo_Fx/Logo_Fx_",
                    "Logo_FX_2" : "Logo_Fx_2/Logo_Fx_2_",
                    "W_Split_Land" : "W_Split_Land/W_Split_Land_",
                    "W_Split_Win" : "W_Split_Win/W_4_WIN_",
                    "JW_Reveal" : "JW_Reveal/JW_Reveal_",

                    "explosion" : "Effects/fire/fire_",

                    "borderFire" : "FIYA/FIYA_",

                    "Reels_Landing" : "Reels_Landing/Reels_Land_",
                    
                    "Anticipation" : "Anticipation/anticipation_",

                    "Burning_Badge" : "JW_Badge_Burning/Badge_BURNING_",
                    "Burning_Badge_Big" : "JW_Badge_Burning_Big/JW_Badge_Burning_Big_",

                    "JW_Indicator_Light" : "JW_Indicator_Light/JW_Indicator_Light_",
                    "Toapapper" : "Toapapper/Paper_Roll_",
                    
                    "Mystery_Explode" : "Mystery_Explode/M_Explode_",


                    "split" : "split/split_",

                    "doorSparks":"fs_door/sparks/sparks_",
                    "doorDropSparks":"fs_door/sparks2/sparks2_",

                    "XWays_Effects":"Effects/xways/XN_frame_"

                }
            },
            {
                name : "symbolsHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : []
            },
            {
                name : "symbols",
                assets : []
            },
            {
                name : "spine",
                assets : []
            },
        ]
    };
    

    public static buildAssetPaths() {
        this.applyTexturePaths(TextureSheets.intro, this.RESOURCES_GROUPS.intro);
        this.applyTexturePaths(TextureSheets.main, this.RESOURCES_GROUPS.main);

        const spineIndex = this.RESOURCES_GROUPS.main.findIndex(group => group.name === SpineAssets.name);
        
        if (spineIndex >= 0) {
            this.RESOURCES_GROUPS.main[spineIndex].assets = [];
            SpineAssets.assets.forEach(asset => {
                this.RESOURCES_GROUPS.main[spineIndex].assets.push(new SpineAsset(asset.SpineName, asset.path));
            });
        }else{
            this.RESOURCES_GROUPS.main.push({ name: SpineAssets.name, assets: [] });
            SpineAssets.assets.forEach(asset => {
                this.RESOURCES_GROUPS.main[this.RESOURCES_GROUPS.main.length - 1].assets.push(new SpineAsset(asset.SpineName, asset.path));
            });
        }
    }

    private static applyTexturePaths(texturePaths: ITexturePath[], targetResourceGroups: AssetsGroup[]) {
        texturePaths.forEach(texturePath => {
            const { SheetName, Assets } = texturePath;
            let targetGroup:AssetsGroup | undefined = targetResourceGroups.find(group => group.name === SheetName);

            if (!targetGroup) {
                targetGroup = { name: SheetName, assets: [] };
                targetResourceGroups.push(targetGroup);
            } else {
                targetGroup.assets = [];
            }
            
            Assets.forEach(asset => {
                targetGroup!.assets.push(new TextureAsset(asset.name, asset.path));
            });
        });
    }
}
